import React from 'react'
import { useHighlightedText } from '../../hooks/useHighlightedText'
import '../../styles/HeadingModule/Heading.scss'

export interface HeadingProps {
  text: React.ReactNode
  as?: 'h1' | 'h2'
  className?: string
  id?: string
}

/**
 * Generic, presentational heading: renders `text` (with `{highlight}` tokens
 * resolved) into the given tag and class. `text` may be a plain string or
 * pre-resolved markup (e.g. a first-name `mp-mask` span produced by the
 * consuming module); page-specific concerns like personalization live there.
 */
export const Heading = ({ text, as: Tag = 'h1', className = 'heading', id }: HeadingProps) => {
  return <Tag id={id} className={className}>{useHighlightedText(text)}</Tag>
}
